module.exports = __webpack_public_path__ + "img/icon6.f9ca8941.svg";